import React from 'react';

function HeaderSkeleton({ Skeleton }) {
    return (
        <div className="rounded-lg w-full bg-[#FFFFFF] border border-[#EBEBEB] shadow-s5 pt-4 pl-[22px] pr-7 pb-7 flex">
            <div className="w-1/2">
                <div className="flex items-center">
                    <Skeleton borderRadius="50%" width="90px" height="90px" />
                    <div className="pl-7">
                        <p className="text-3xl font-bold text-[#090406] mb-3"><Skeleton width="200px" className="mb-2" /></p>
                        {' '}
                        <p className="text-xl font-normal text-[#A1A1A1]"><Skeleton width="100px" height="25px" /></p>
                    </div>
                </div>
                <div className="pt-[26px]">
                    <p className="text-xs7 font-normal text-[#A1A1A1] mb-3"><Skeleton width="80px" height="15px" /></p>
                    <p className="text-xs7 font-normal text-[#090406]">
                        {' '}
                        <Skeleton width="100px" height="15px" />
                    </p>
                </div>
                <div className="pt-2.5 flex mb-2">
                    <div className="">
                        <p className="text-xl font-normal text-[#A1A1A1] mb-2"><Skeleton width="140px" height="22px" /></p>
                        <p className="text-xl font-normal text-[#090406]"><Skeleton width="140px" height="22px" /></p>
                    </div>
                    <div className="pl-[46px]">
                        <p className="text-xl font-normal text-[#A1A1A1] mb-2"><Skeleton width="140px" height="22px" /></p>
                        <p className="text-xl font-normal text-[#090406] mb-2"><Skeleton width="140px" height="22px" /></p>
                    </div>
                </div>
                <div className="pt-4">
                    <p className="text-xs5 font-normal text-[#555259]">
                        {' '}
                        <span className="text-[#090406]"><Skeleton width="250px" height="10px" /></span>
                    </p>
                </div>
            </div>
            <div className="w-1/2">
                <p className="text-lg font-normal text-[#A1A1A1] mb-2"><Skeleton width="140px" height="17px" /></p>
                <p className="text-xs8 font-bold text-[#090406] mb-2"><Skeleton width="200px" height="19px" /></p>
                <div className="pt-[18px] flex">
                    <div className="w-1/2 ">
                        <p className="text-xl font-normal text-[#A1A1A1] mb-2"><Skeleton width="180px" height="24px" /></p>
                        <p className="text-xl font-normal text-[#090406] mb-2"><Skeleton width="180px" height="24px" /></p>
                    </div>
                    <div className="w-1/2">
                        <p className="text-xl font-normal text-[#A1A1A1] mb-2"><Skeleton width="180px" height="24px" /></p>
                        <p className="text-xl font-normal text-[#090406]"><Skeleton width="180px" height="24px" /></p>
                    </div>
                </div>
                <div className="pt-[18px]">
                    <div className="flex">
                        <p className="text-xl font-normal text-[#A1A1A1]"><Skeleton width="30px" height="22px" /></p>
                        <p className="text-xl font-normal text-[#090406] pl-[26px]"><Skeleton width="220px" height="22px" /></p>
                    </div>
                    <div className="pt-1 flex">
                        <p className="text-xl font-normal text-[#A1A1A1]"><Skeleton width="30px" height="22px" /></p>
                        <p className="text-xl font-normal text-[#090406] pl-[26px]"><Skeleton width="150px" height="22px" /></p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default HeaderSkeleton;
